import { render, staticRenderFns } from "./RoomUpload.vue?vue&type=template&id=ceb55208&"
import script from "./RoomUpload.vue?vue&type=script&lang=ts&"
export * from "./RoomUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports